/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 */
//入口
// import { order } from '../../api';
// import importAll from '@/tools/importAll';
// const children  = importAll(require.context('./'))

import { orderManagement } from '@/api/ajax';
import fields from '@/page/settlementCenter/projectSettled/common/fields.js';
import search from '@/page/settlementCenter/projectSettled/common/search.js';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import createExtend from '@/components/createExtend.js';
import orderCreate from '../child/orderCreate/index';
import _fields from './fields.js';
import { userEnterpriseType as userEnterpriseTypeSearch } from '@/page/settlementCenter/common/tableConfig/search.js';
import { userEnterpriseType as userEnterpriseTypeField } from '@/page/settlementCenter/common/tableConfig/fields.js';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';

//初始化
const example = new TableRenderClass({
  fields: { ...fields, ..._fields },
  search
});

/*主页面入口*/
export const main = [
  {
    name: '项目结算管理',
    childMenu: [
      example.createPart({
        name: '结算订单|列表',
        search: [
          'projectNameAndId',
          userEnterpriseTypeSearch,
          'jiesuangongyingshang',
          'payStatus',
          'fufuweizhuangtai',
          'bussniessServicesStatus',
          'createDate',
          'industryId',
          PAY_BANK_TYPE_KEY,
          PAY_TYPE_KEY,
          'industryFenpeiCode'
        ],
        list: orderManagement.settlementList,
        requestNow: true,
        defaultQuery: {},
        fields: [
          'index',
          'xiangmumingcheng',
          PAY_BANK_TYPE_KEY,
          PAY_TYPE_KEY,
          'industryFenpeiCode',
          userEnterpriseTypeField,
          'projectSubmit',
          'industryName',
          'supplierName_rateList',
          'payPrice',
          'projectPrice',
          'link_zhifujindu',
          'serviceStatus',
          'bussniessServicesStatus',
          'zhifuzhuangtai',
          'listProjectCheckManageAction'
        ],
        moreBtnArr: [
          {
            name: '生成自然人订单',
            fn: (a, table) => {
              // 点击后生成后续唯一cacheKey
              table.$store.commit('projectSettled/SET_CACHE_KEY', Date.now());
              // 后续所有接口添加projectSettled参数
              // 关联到了request store router
              table.$store.commit('projectSettled/SET_SETTLED', {
                userEnterpriseType: 1
              });
              setTimeout(() => {
                const creator = createExtend(orderCreate, {
                  userEnterpriseType: 1
                });
                creator['$on']('finished', () => {
                  table.init();
                });
                // 关闭弹层后清除
                creator['$on']('close', () => {
                  table.$store.commit('projectSettled/SET_SETTLED', {});
                });
              }, 1000);
              // table.$parent.toggleActionsVisible('create');
            }
          },
          {
            name: '生成个体订单',
            fn: (a, table) => {
              table.$store.commit('projectSettled/SET_CACHE_KEY', Date.now());
              // 后续所有接口添加projectSettled参数
              table.$store.commit('projectSettled/SET_SETTLED', {
                userEnterpriseType: 3
              });
              setTimeout(() => {
                const creator = createExtend(orderCreate, {
                  userEnterpriseType: 3
                });
                creator['$on']('finished', () => {
                  table.init();
                });
                // 关闭弹层后清除
                creator['$on']('close', () => {
                  table.$store.commit('projectSettled/SET_SETTLED', {});
                });
              }, 1000);
              // table.$parent.toggleActionsVisible('create');
            }
          }
        ]
      })
    ]
  }
];
